// ============================================
// DASHBOARD COMPONENTS - Initialize all dashboard widgets
// ============================================

import { registerOrdersWidgetCard } from './orders-widget-card';
import { registerUserDataConsumer } from './user-data-consumer';

export function initDashboardComponents(): void {
    registerOrdersWidgetCard();
    registerUserDataConsumer();
    // Add more dashboard widgets here
}
